import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2Font4xlBoldProps extends ITextBoxProps {}

export const TextBoxMaxLine2Font4xlBold = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Font4xlBold,
  alignment = TextAligning.Left,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2Font4xlBoldProps): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
